<template>
  <main class="exhibition" v-if="exhibition" :key="exhibition.uid">
    <top-bar
      v-if="exhibition.title"
      :left="!exhibition.hideenddate ? exhibition.startdate + ' – ' + exhibition.enddate : exhibition.startdate"
      :center="exhibition.title + ' – ' + exhibition.subtitle"
      :right="exhibition.location"
      :active="contentVisible"
      v-on:toggle-content="scrollToText"
    />
    <div class="background">
      <div
        v-if="exhibition.cover || exhibition.video"
        class="fixed"
        @mouseenter="mouseHide = false"
        @mousemove="moveMouse"
        @mouseleave="mouseHide = true"
      >
        <div
          class="scroll-down"
          :class="{ hide: mouseHide }"
          @click="scrollDown"
          :style="{
            top: mouseY + 'px',
            left: mouseX + 'px',
          }"
        >
          SCROLL DOWN
        </div>
        <img
          v-if="!exhibition.video || exhibition.videohome"
          v-lazy="exhibition.cover.thumb"
          :data-srcset="exhibition.cover.srcset"
          :alt="exhibition.title"
        />
        <video-player
          v-else
          :videolink="exhibition.video"
          :videocontrols="exhibition.videocontrols"
          :poster="exhibition.cover.url"
          v-on:scroll-down="scrollDown"
        />
      </div>
      <div
        class="gallery"
        id="gallery"
      >

        <div
          class="gallery-image"
        >
          <div class="slide-wrap">
            <img
              v-lazy="exhibition.first.thumb"
              :data-srcset="exhibition.first.srcset"
              :alt="exhibition.title"
            />
            <figcaption v-if="exhibition.first.caption" v-html="exhibition.first.caption"></figcaption>
          </div>
        </div>

        <template v-if="exhibition.recording && exhibition.recording.template == 'collection'">
          <router-link 
          :to="{ 
            name: 'recording-inner', 
            params: { lang: $i18n.locale, uid: exhibition.recording.uid, collection: exhibition.recording.parent } }" class="exhibition-recording" v-if="exhibition.recording">
            <div>
              <img :src="'https://vumbnail.com/' + exhibition.recording.vimeoid + '.jpg'" alt="">
              <img class="play-btn" src="@/assets/play.svg" alt="play" />
            </div>
            <div class="pad" v-html="exhibition.recording.description">
            </div>
          </router-link>
        </template>
        <template v-else>
          <router-link 
          :to="{ 
            name: 'recording-inner', 
            params: { lang: $i18n.locale, uid: exhibition.recording.uid } }" class="exhibition-recording" v-if="exhibition.recording">
            <div>
              <img :src="'https://vumbnail.com/' + exhibition.recording.vimeoid + '.jpg'" alt="">
              <img class="play-btn" src="@/assets/play.svg" alt="play" />
            </div>
            <div class="pad" v-html="exhibition.recording.description">
            </div>
          </router-link>
        </template>

                    <!-- <router-link
              v-if="exhibition.recording"
              class="watch-link"
              :to="{
                name: 'recording',
                params: { lang: $i18n.locale, uid: exhibition.recording.uid },
              }"
              ><img class="play-btn" src="@/assets/play.svg" alt="play" /> Watch the
              Video</router-link
            > -->

        <div ref="content" class="content-box">
          <div class="credits">
            <span class="exhibition-title">{{ exhibition.title }}</span>
              <br>
              {{ exhibition.subtitle }}<br>
              <span v-if="!exhibition.showmultiple">{{ exhibition.startdate }}<span v-if="!exhibition.hideenddate"> - {{ exhibition.enddate }}</span></span>
            <span v-else v-html="exhibition.multipledates"></span>
             <br>{{ exhibition.location }}
          </div>
          <div class="col">
            <div v-html="exhibition.extra" />
          </div>
          <div class="col-2">
            <div class="mb" v-html="exhibition.description" />
          </div>
          <div
            class="credits"
            v-if="exhibition.credits"
            v-html="exhibition.credits"
          />
        </div>

        <div
          v-for="(image, index) in exhibition.gallery"
          :key="index"
          class="gallery-image"
        >
          <div class="slide-wrap">
            <img
              v-lazy="image.thumb"
              :data-srcset="image.srcset"
              :alt="exhibition.title"
            />
            <figcaption v-if="image.caption" v-html="image.caption"></figcaption>
          </div>
        </div>

      </div>



    </div>
  </main>
</template>

<script>
import API from "@/api/service";
const TopBar = () =>
  import(/* webpackChunkName: "TopBar" */ "@/components/TopBar.vue");
const VideoPlayer = () =>
  import(/* webpackChunkName: "VideoPlayer" */ "@/components/VideoPlayer.vue");
import isMobile from "@/mixins/isMobile";
export default {
  name: "exhibition",
  metaInfo() {
    return {
      title: "– " + this.exhibition.title,
    };
  },
  components: {
    TopBar,
    VideoPlayer,
  },
  data() {
    return {
      exhibition: [],
      contentVisible: false,
      mouseX: 0,
      mouseY: 0,
      mouseHide: false,
    };
  },
  onIdle() {
    if (window.scrollY < window.innerHeight / 2 || this.isMobile()) {
      this.mouseHide = true;
    }
  },
  onActive() {
    if (window.scrollY > window.innerHeight / 2 || this.isMobile()) {
      this.mouseHide = true;
    } else {
      this.mouseHide = false;
    }
  },
  mixins: [isMobile],
  watch: {
    $route(to, from) {
      if (to.params.lang !== from.params.lang) {
        this.exhibition = [];
        API.exhibition(this.$i18n.locale, this.$route.params.uid).then(
          (page) => {
            this.exhibition = page.data.result;
          }
        );
      }
    },
  },
  async created() {
    API.exhibition(this.$i18n.locale, this.$route.params.uid).then((page) => {
      this.exhibition = page.data.result;
    });
  },
  methods: {
    scrollToText() {
      let wh = (window.innerWidth < 768) ? -50 : window.innerHeight - 80;
      let offset = this.$refs.content.offsetTop + wh;
      // console.log(offset);
      window.scroll({top: offset, behavior: "smooth"});
    },
    moveMouse(event) {
      if (this.isMobile()) {
        this.mouseX = window.innerWidth / 2;
        this.mouseY = window.innerHeight / 2;
      } else {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
      }
    },
    scrollDown() {
      let options = {
        offset: 0,
      };
      this.$scrollTo("#gallery", 1000, options);
    },
    toggleContent() {
      this.contentVisible = !this.contentVisible;
    },
  },
  filters: {
    parse(value) {
      if (value === "artisttalk") {
        return "artist talk";
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="scss">
.background {
  width: 100%;
  min-height: 100%;
  .fixed {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .gallery {
    position: absolute;
    margin-top: 100vh;
    padding-bottom:30vh;
    width: 100%;
    @media only screen and (max-width: 768px) {
      margin-top: 0vh;
    }
    .gallery-image {
      padding: calc(4 * var(--lh)) var(--lh) calc(5 * var(--lh));
      height: 100vh;
      text-align:center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .slide-wrap {
        width:auto;
        height:auto;
        max-width:100%;
        max-height:100%;
        margin-bottom:calc(1 * var(--lh));
        display:inline-block;
        position:relative;
        @media (max-width: 768px) {
          width:100%;
          height:auto;
        }
        @media (min-width: 1280px) and (orientation: landscape) {
          height:100%;
         
        }
      }
      img {
        display:inline-block;
        width: auto !important;
        max-width:100%;
        object-fit:contain !important;
        max-height:100%;
        height:auto !important;
        @media (min-width: 1280px) and (orientation: landscape) {
          height:100% !important;
        }
      }
      figcaption {
        background:black;
        text-align:left;
        // padding-top:0.5rem;
        padding: 0.25rem 0.5rem 0;
        position: absolute;
        top:100%;
        width:100%;
      }
    }
  }
  .scroll-down {
    position: fixed;
    z-index: 997;
    color: var(--bg);
    transform: translate(-50%, -50%);
    cursor: none;
    white-space: nowrap;
    transition: opacity 0.5s;
    @media only screen and (max-width: 768px) {
      top: auto !important;
      bottom: calc(3 * var(--lh)) !important;
      left: var(--lh) !important;
      transform: translate(0%, 0%) !important;
    }
    &.hide {
      opacity: 0;
    }
  }
}
.exhibition-recording {
  margin: 0 auto;
  margin-bottom: calc(4 * var(--lh));
  background: var(--bg);
  max-width: 700px;
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  div {
    position:relative;
  }
  img.play-btn {
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    height:3rem !important;
  }
  .pad {
    grid-column: span 1;
    padding:var(--lh);
  }
}
.exhibition-title {
  text-transform: uppercase;
}
.watch-link {
  text-transform: uppercase;
  margin-top: var(--lh);
  display: inline-block !important;
}
</style>
